import { defineMessages } from "react-intl";

const messages = defineMessages({
  viewMore: {
    id: "searchPromo.viewMore",
    description: "Label for view more button",
    defaultMessage: "View more",
  },
});

export default messages;
